var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "620.000000pt",
    height: "612.000000pt",
    viewBox: "0 0 620.000000 612.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,612.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2440 5215 c0 -20 -5 -25 -25 -25 -20 0 -25 -5 -25 -25 0 -21 -5 -25 -30 -25 -27 0 -30 -3 -30 -30 0 -25 -4 -30 -25 -30 -20 0 -25 -5 -25 -25 l0 -25 -670 0 -670 0 0 -210 0 -210 1930 0 1930 0 0 210 0 210 -670 0 -670 0 0 25 c0 20 -5 25 -25 25 -21 0 -25 5 -25 30 0 27 -3 30 -30 30 -25 0 -30 4 -30 25 0 20 -5 25 -25 25 -20 0 -25 5 -25 25 l0 25 -430 0 -430 0 0 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 4010 l0 -160 25 0 25 0 0 -220 0 -220 23 0 c24 0 24 -1 30 -152 4 -83 7 -191 7 -240 0 -79 2 -88 19 -88 27 0 31 -34 31 -271 l0 -209 25 0 25 0 0 -163 c0 -231 8 -317 30 -317 25 0 30 -44 30 -257 l0 -183 25 0 25 0 0 -160 0 -160 24 0 c21 0 25 -6 31 -50 6 -44 10 -50 31 -50 19 0 24 -5 24 -24 0 -21 6 -25 50 -31 44 -6 50 -10 50 -31 0 -22 4 -24 55 -24 52 0 55 -1 55 -25 l0 -25 964 0 965 0 3 23 c3 19 10 22 61 25 53 3 57 5 57 27 0 23 4 25 50 25 49 0 50 1 50 30 0 25 4 30 24 30 21 0 25 6 31 50 6 44 10 50 31 50 l24 0 0 160 0 160 25 0 25 0 0 168 c0 236 8 322 30 322 25 0 30 44 30 253 l0 177 25 0 25 0 0 240 0 240 25 0 25 0 0 163 c0 90 3 198 6 240 7 72 8 77 30 77 l24 0 0 220 0 220 25 0 25 0 0 160 0 160 -1610 0 -1610 0 0 -160z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b4161bf903cebda94976186a30cb3858.svg";
export { ForwardRef as ReactComponent };